import classNames from "classnames";
import { Immutable } from "immer";
import React from "react";

import { LoadingSpinner } from "../../../components/LoadingSpinner";
import { ConfiguratorTypes } from "../../../constants";

type IProps = Immutable<{
    configuratorType: ConfiguratorTypes;
    alternatePriceView?: boolean;
    errorMessage?: string | null;
}>;

export const ConfiguratorPriceLoading = (props: IProps): React.JSX.Element => {
    const priceClasses = classNames({
        "configurator__price": true,
        "configurator__price--loading": !props.errorMessage,
        "configurator__price--error": !!props.errorMessage,
        [`configurator__price--${props.configuratorType}`]: true,
        "configurator__price--alternate": props.alternatePriceView,
    });
    return (
        <div className={priceClasses}>
            {props.errorMessage ? (
                <p className="configurator__price--error-message" role="alert">
                    {props.errorMessage}
                </p>
            ) : (
                <LoadingSpinner />
            )}
        </div>
    );
};
